import { BTable, BFormGroup, BFormInput, BFormCheckbox, } from "bootstrap-vue";
import Loading from '@@/core/components/shared/Loading/Loading'

export default {
    name: "SalesManagement",
    components: {
        Loading,
        BTable, BFormGroup, BFormInput, BFormCheckbox
    },
    data() {
        return {
            sellers: [],

            intervalId: null,
        };
    },
    watch: {
    },
    mounted() {
        this.loadData();
        this.intervalId = setInterval(() => {
            this.loadData();
        }, 30000);
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },


    methods: {
        async loadData() {
            const response = await this.$axios(`admin/sellers-list-special`);
            this.sellers = response.data.data.sellers;
        }
    },
};